// Library Methods
import { useContext } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SummarySection from "./SummarySection/SummarySection";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

const StereopsisGraph = () => {
  const { t } = useTranslation();
  const { examReport } = useContext(ReportSectionContext);

  const stereoLadder = examReport?.postProcessing?.summary?.StereoLadder;

  if (!stereoLadder) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography fontSize="14px" fontWeight={600} color="#E10C0C">
          {t("No Data Available.")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" width="100%" gap="24px">
      <SummarySection
        summary={examReport?.postProcessing?.summary}
        stereoLadderModule={examReport?.postProcessing?.modules?.StereoLadder}
      />
    </Box>
  );
};

export default StereopsisGraph;
